// Select all of the galleries on the page and loop through them
const galleries = document.querySelectorAll('.gallery');
galleries.forEach(() => {
    // Create a separate gallery lightbox for each set of images
    const galleryLightbox = GLightbox({
        selector: '.gallery ul li a',
        type: 'image'
    });
});